import { useContext, useEffect, useState } from 'react';
import Close from '../../../../../Assets/Modals/closeIcon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from '../../../../../Features/storefrontSlice';
import SearchIcon from '../../../../../Assets/OrderManagement/SearchIcon.svg';
import { useNavigate } from 'react-router-dom';
import { getCachedMediaUrl } from '../../../../../lib/utils/utils';
import { StorefrontContext } from '../../../../../Context/StorefrontContext';
import { showToast } from '../../../../../Components/Toaster/Toaster';
import { apiV1 } from '../../../../../Auth/Interceptor';

function SelectCustomCollection() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const sectionFormType = useSelector((state) => state.storefront.sectionFormType);
    const selectedCarouselBannerSection = useSelector((state) => state.storefront.selectedCarouselBannerSection);

    const handleCloseButtonClick = () => {
        dispatch(closeModal());
    };

    const {
        setSelectedCategory,
        setSelectedCollection,
        setSelectedProducts,
        setSelectedCustomCollection,

        singleBanner,
        defaultSingleBanner,
        setSingleBanner,

        setCarouselBanner,

        customCollection,
        setCustomCollection,
        setSingleBannerDesktop,
        singleBannerDesktop,
        setCarouselBannerDesktop,
        setCustomCollectionDesktop,
        customCollectionDesktop,
    } = useContext(StorefrontContext);

    const [customCollectionSearchText, setCustomCollectionSearchText] = useState('');

    const handleCollectionSearch = (e) => {
        setCustomCollectionSearchText(e.target.value);
    }

    const [selectedCustomCollectionId, setSelectedCustomCollectionId] = useState('');
    const [customCollections, setCustomCollections] = useState([]);
    const [customCollectionSearchList, setCustomCollectionSearchList] = useState([]);

    const [buttonAvailable, setButtonAvailable] = useState(false);

    const handleCustomCollectionClick = (e) => {
        setSelectedCustomCollectionId(e.target.value);
    }

    const handleCollectionSearchKeyDown = (e) => {
        if(e.key === 'Enter') {
            if(customCollectionSearchText) {
                const filteredList = customCollections.filter(collection => collection.CollectionName.toLowerCase().includes(customCollectionSearchText.toLowerCase()));
                if(filteredList.some(customCollection => customCollection.id !== selectedCustomCollectionId)) {
                    setSelectedCustomCollectionId('');
                }
                setCustomCollectionSearchList(filteredList);
            }
        }
    }

    const handleSetCollection = () => {
        if(buttonAvailable) {
            const customCollectionItem = customCollectionSearchList.find(item => item.id === selectedCustomCollectionId);
            if(sectionFormType === 'SINGLE_BANNER') {
                setSingleBanner({
                    ...defaultSingleBanner,
                    image: singleBanner.image,
                    customCollection: customCollectionItem,
                });
            }
            if(sectionFormType === 'SINGLE_BANNER_DESKTOP') {
                setSingleBannerDesktop({
                    ...defaultSingleBanner,
                    image: singleBannerDesktop.image,
                    customCollection: customCollectionItem,
                });
            }
            if(sectionFormType === 'CAROUSEL_BANNER') {
                setCarouselBanner((prevCarouselBanner) =>
                    prevCarouselBanner.map((item) =>
                        item.title === selectedCarouselBannerSection
                            ? { ...item, link: { ...defaultSingleBanner, customCollection: customCollectionItem, } } 
                            : item
                    )
                );
            }
            if(sectionFormType === 'CAROUSEL_BANNER_DESKTOP') {
                setCarouselBannerDesktop((prevCarouselBanner) =>
                    prevCarouselBanner.map((item) =>
                        item.title === selectedCarouselBannerSection
                            ? { ...item, link: { ...defaultSingleBanner, customCollection: customCollectionItem, } } 
                            : item
                    )
                );
            }
            if(sectionFormType === 'CUSTOM_COLLECTION_LIST') {
                setCustomCollection({
                    ...customCollection,
                    customCollection: customCollectionItem,
                });
            }
            if(sectionFormType === 'CUSTOM_COLLECTION_LIST_DESKTOP') {
                setCustomCollectionDesktop({
                    ...customCollectionDesktop,
                    customCollection: customCollectionItem,
                });
            }
            setSelectedCategory({});
            setSelectedCollection({});
            setSelectedCustomCollection({});
            setSelectedProducts([]);
            dispatch(closeModal());
        }
        else {
            showToast('Please select a custom collection.', 'warning');
        }
    }

    const handleCreateCustomCollection = () => {
        dispatch(closeModal());
        navigate('/collections/custom-collections/add-custom-collection');
    }

    useEffect(() => {
        if(selectedCustomCollectionId) {
            setButtonAvailable(true);
        }
        else {
            setButtonAvailable(false);
        }
    }, [selectedCustomCollectionId]);

    useEffect(() => {
        const fetchCustomCollections = async () => {
            try {
                const response = await apiV1.get('customCollection/getAll');
                if(response?.status === 200) {
                    setCustomCollections(response.data.data.collection);
                    setCustomCollectionSearchList(response.data.data.collection);
                }
                else {
                    showToast('Error fetching custom collections.', 'error');
                }
            }
            catch(err) {
                showToast('Error fetching custom collections.', 'error');
            }
        }

        fetchCustomCollections();
    }, []);

    useEffect(() => {
        if(!customCollectionSearchText) {
            setCustomCollectionSearchList(customCollections);
        }
        // eslint-disable-next-line
    }, [customCollectionSearchText]);

    return (
        <div className='w-[28%] rounded-[20px] overflow-hidden bg-[#FFFFFF] shadow-[0px_0px_12px_0px_#0000003D] relative'>
            <div className="flex items-center justify-between pt-[18px] pl-6 pr-2 w-full">
                <h1 className='font-semibold text-2xl text-[#121212]'>Set Custom Collection</h1>

                <button className='size-11 flex items-center justify-center outline-none' onClick={handleCloseButtonClick}>
                    <img src={Close} alt="Close Modal" />
                </button>
            </div>

            <div className="border border-[#EAEAEA] bg-[#F5F5F5] px-4 py-[10px] rounded-lg flex items-center gap-1 mx-6 mt-2">
                <div className="size-5 flex items-center justify-center">
                    <img src={SearchIcon} alt="" />
                </div>

                <input 
                    name='custom-collection' 
                    id='custom-collection' 
                    className='w-[calc(100%-20px)] bg-transparent outline-none font-medium text-[14px] leading-[22px] text-[#121212] placeholder:text-[#666666]' 
                    type="text" 
                    placeholder='Search custom collection' 
                    value={customCollectionSearchText} 
                    onChange={handleCollectionSearch} 
                    onKeyDown={handleCollectionSearchKeyDown} 
                />
            </div>

            <div className="mt-4 flex flex-col mb-[84px] max-h-96 overflow-y-scroll no-scrollbar">
                {
                    customCollections.length > 0 ?
                    <>
                        {customCollectionSearchList?.map(customCollection => {
                            return (
                                <label htmlFor={`${customCollection.id}-radio`} key={customCollection.id} className="px-6 py-3 flex items-center gap-2 hover:bg-[#F5F5F5] cursor-pointer">
                                    <div className="cursor-pointer size-4 flex items-center justify-center">
                                        <div className={`size-full rounded-full border flex items-center justify-center ${selectedCustomCollectionId === customCollection.id ? 'border-primaryColor' : 'border-[#757575]'}`}>
                                            {
                                                selectedCustomCollectionId === customCollection.id && 
                                                <div className="w-2 h-2 rounded-full bg-primaryColor"></div>
                                            }
                                        </div>
                                    </div>

                                    <div className='w-[calc(100%-16px-8px)] select-none flex items-center gap-2'>
                                        <input 
                                            id={`${customCollection.id}-radio`} 
                                            value={customCollection.id} 
                                            type="radio" 
                                            checked={selectedCustomCollectionId === customCollection.id} 
                                            onChange={handleCustomCollectionClick} 
                                            className='hidden' 
                                        />

                                        <div className="size-[52px] rounded-[7px] overflow-hidden flex items-center justify-center bg-[#D9D9D9]">
                                            <img className='size-full object-cover' src={getCachedMediaUrl(customCollection?.CollectionImgUrl[0])} alt="" />
                                        </div>

                                        <p className='w-[calc(100%-52px-8px)] whitespace-nowrap overflow-hidden text-ellipsis font-medium text-[16px] leading-5 text-[#000000]'>{customCollection.CollectionName}</p>
                                    </div>
                                </label>
                            )
                        })}
                    </> : 
                    <div className='px-6 pt-3 pb-4'>
                        <p className='italic text-[14px] leading-[26px] text-[#666666]'>Oops! Looks like you don't have any custom collections. <span onClick={handleCreateCustomCollection} className='cursor-pointer text-[#4F46E5]'>Create one here</span>.</p>
                    </div>
                }
            </div>

            <div className="p-6 absolute left-0 bottom-0 w-full bg-[#FFFFFF] shadow-[0px_-3px_6px_0px_#0000001F]">
                <button onClick={handleSetCollection} className={`w-full px-4 py-[6px] rounded-md font-semibold text-[12px] leading-6 text-buttonText ${buttonAvailable ? 'bg-primaryColor hover:bg-primaryAccent' : 'bg-buttonDisabledBg cursor-not-allowed'}`}>Set</button>
            </div>
        </div>
    );
}

export default SelectCustomCollection;
